import { render, staticRenderFns } from "./ResultIpinAuthPop.vue?vue&type=template&id=73c76a06&scoped=true&"
import script from "./ResultIpinAuthPop.vue?vue&type=script&lang=js&"
export * from "./ResultIpinAuthPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c76a06",
  null
  
)

export default component.exports